<template>
  <div>
    <!--begin::Dashboard-->
    <div class="row">
      <div class="col-md-12 order-2 order-xxl-1">
        <!--begin::Advance Table Widget 2-->
        <div class="card card-custom card-stretch gutter-b">
          <!--begin::Header-->
          <div class="card-header border-0 pt-5">
            <h3 class="card-title align-items-start flex-column">
              <span class="card-label font-weight-bolder text-dark">
                {{currentUser.nombreUsuario}}
              </span>
              <span class="text-muted mt-3 font-weight-bold font-size-sm">
                {{currentUser.nombreRol}}
              </span>
            </h3>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body pt-3 pb-0">
            <!--begin::Table-->
            <div class="table-responsive">
              <table class="table table-borderless table-vertical-center">
                <thead>
                  <tr>
                    <th class="p-0" style="width: 50px"></th>
                    <th class="p-0" style="min-width: 200px"></th>
                    <th class="p-0" style="min-width: 150px"></th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(item, i) in dataToShow">
                    <tr v-bind:key="i">
                     
                      <td class="pl-0 py-4">
                         <router-link v-if="currentRoles && currentRoles.includes(1)"
                          :to="item.link"
                        >
                        <div class="symbol symbol-50 symbol-light mr-1">
                          <span class="symbol-label">
                            <i :class="item.text0"></i>
                          </span>
                        </div>
                        </router-link>
                      </td>
                      <td class="pl-0">
                         <router-link v-if="currentRoles && currentRoles.includes(1)"
                          :to="item.link"
                        >
                        <a
                          class="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg"
                        >
                          {{ item.text1 }}
                        </a>
                        <div>
                          <span class="font-weight-bolder"></span>
                          <a class="text-muted font-weight-bold text-hover-primary">
                            {{ item.text2 }}
                          </a>
                        </div>
                         </router-link>
                      </td>
                       <router-link v-if="currentRoles && currentRoles.includes(1)"
                          :to="item.link"
                        >
                      <td class="text-right pr-0">
                        <a class="btn btn-icon btn-light btn-sm">
                          <span class="svg-icon svg-icon-md svg-icon-primary">
                            <!--begin::Svg Icon-->
                            <inline-svg
                              src="media/svg/icons/General/Settings-1.svg"
                            ></inline-svg>
                            <!--end::Svg Icon-->
                          </span>
                        </a>
                        <a class="btn btn-icon btn-light btn-sm mx-3 d-none">
                          <span class="svg-icon svg-icon-md svg-icon-primary">
                            <!--begin::Svg Icon-->
                            <inline-svg
                              src="media/svg/icons/Communication/Write.svg"
                            ></inline-svg>
                            <!--end::Svg Icon-->
                          </span>
                        </a>
                        <a class="btn btn-icon btn-light btn-sm d-none">
                          <span class="svg-icon svg-icon-md svg-icon-primary">
                            <!--begin::Svg Icon-->
                            <inline-svg
                              src="media/svg/icons/General/Trash.svg"
                            ></inline-svg>
                            <!--end::Svg Icon-->
                          </span>
                        </a>
                      </td>
                       </router-link>
                      
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <!--end::Table-->
          </div>
      <!--end::Body-->
      <!--end::Advance Table Widget 2-->
        </div>



        
    </div>
    <!--<div class="row">
      <div class="col-xxl-4">
        <MixedWidget1></MixedWidget1>
      </div>
      <div class="col-xxl-4">
        <ListWidget9></ListWidget9>
      </div>
      <div class="col-xxl-4">
        <StatsWidget7></StatsWidget7>
        <StatsWidget12></StatsWidget12>
      </div>

      <div class="col-xxl-4 order-1 order-xxl-1">
        <ListWidget1></ListWidget1>
      </div>
      <div class="col-xxl-8 order-2 order-xxl-1">
        <AdvancedTableWidget2></AdvancedTableWidget2>
      </div>

      <div class="col-xxl-4 order-1 order-xxl-2">
        <ListWidget3></ListWidget3>
      </div>
      <div class="col-xxl-4 order-1 order-xxl-2">
        <ListWidget4></ListWidget4>
      </div>
      <div class="col-lg-12 col-xxl-4 order-1 order-xxl-2">
        <ListWidget8></ListWidget8>
      </div>

      <div class="col-xxl-4 order-1 order-xxl-2">
        <StatsWidget13></StatsWidget13>
      </div>
      <div class="col-xxl-8 order-1 order-xxl-2">
        <AdvancedTableWidget3></AdvancedTableWidget3>
      </div>
    </div>-->

   
    <!--end::Dashboard-->
  </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
/*import AdvancedTableWidget2 from "@/view/content/widgets/advance-table/Widget2.vue";
import AdvancedTableWidget3 from "@/view/content/widgets/advance-table/Widget3.vue";
import MixedWidget1 from "@/view/content/widgets/mixed/Widget1.vue";
import ListWidget1 from "@/view/content/widgets/list/Widget1.vue";
import ListWidget3 from "@/view/content/widgets/list/Widget3.vue";
import ListWidget4 from "@/view/content/widgets/list/Widget4.vue";
import ListWidget8 from "@/view/content/widgets/list/Widget8.vue";
import ListWidget9 from "@/view/content/widgets/list/Widget9.vue";
import StatsWidget7 from "@/view/content/widgets/stats/Widget7.vue";
import StatsWidget12 from "@/view/content/widgets/stats/Widget12.vue";
import StatsWidget13 from "@/view/content/widgets/stats/Widget13.vue";*/

export default {
  name: "dashboard",
  data() {
    return {
      show: "admin",
     
      admin: [
       
        {
          text0: "fas fa-check-double",
          text1: "Aprobadores y Revisores",
          text2: "Aprobadores y Revisores de las instituciones",
          link: "/admin/institucion/usuarios/registro",
          text4: "ReactJs, HTML",
          text5: "Approved",
          text6: "primary"
        },
        {
          text0: "fas fa-people-arrows",
          text1: "Asignación de Aprobadores y Revisores",
          text2: "Asinga los aprobadores y revisores a las municipalidades por periodo",
          link: "/admin/institucion/usuarios/asignacion-muni-periodo",
          text4: "Python, MySQL",
          text5: "In Progress",
          text6: "warning"
        }
      ],
    };
  },
  components: {
    /*AdvancedTableWidget2,
   /* AdvancedTableWidget3,
    MixedWidget1,
    ListWidget1,
    ListWidget3,
    ListWidget4,
    ListWidget8,
    ListWidget9,
    StatsWidget7,
    StatsWidget12,
    StatsWidget13*/
    
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Dashboard" }]);
  },
  methods: {
    setActiveTab1(event) {
      this.tabIndex = this.setActiveTab(event);
    },
    setActiveTab2(event) {
      this.tabIndex2 = this.setActiveTab(event);
    },
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      // get all tab links
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set current active tab
      event.target.classList.add("active");

      // set clicked tab index to bootstrap tab
      return parseInt(event.target.getAttribute("data-tab"));
    }
  },
  computed:{
    ...mapGetters(["currentUser"]),
    ...mapGetters(["currentRoles"]),
    ...mapGetters(["layoutConfig"]),
    dataToShow() {
      if (this.show === "month") return this.month;
     
      if (this.show === "admin") return this.admin;
      return this.day;
    }
  }
};
</script>
